import React from 'react';
import { PAIN_HEADLINE, PAIN_TRANSITION, PAIN_TRANSITION_EMPHASIS, painCards } from '../data/poolContent';
export function PainSection() {
  return <section className="w-full bg-abyss-900 py-14 sm:py-20" aria-labelledby="pain-title" data-id="element-263" data-mp="38vu5g27ipv0y">
      <div className="mx-auto max-w-6xl px-5" data-id="element-264" data-mp="2v08brhqcan27">
        <h2 id="pain-title" className="text-center font-display text-[2.1rem] font-bold uppercase leading-none text-frost-50 sm:text-[3rem]" data-id="element-265" data-mp="2yyzblwm6wit0">
          {PAIN_HEADLINE}
        </h2>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-266" data-mp="2q044mibbn4on">
          {painCards.map(card => <li key={card.title} className="flex flex-col overflow-hidden rounded-2xl border border-abyss-600 bg-abyss-800" data-id="element-267" data-mp="2bbhd7i8f6mh2">
              <img src={card.image} alt={card.alt} className="aspect-[16/10] w-full object-cover sm:aspect-[4/3]" width={1200} height={900} loading="lazy" data-id="element-268" data-mp="228yf1bfkwy15" />
              <div className="flex flex-1 flex-col p-4 sm:p-5" data-id="element-269" data-mp="3rovgj3mz2udd">
                <h3 className="font-display text-[1.5rem] font-bold uppercase leading-[1.05] text-frost-50" data-id="element-270" data-mp="3nknp2yp4r0bg">
                  {card.title}
                </h3>
                <div className="mt-3 space-y-1" data-id="element-271" data-mp="gzh16sj1qiw">
                  {card.lines.map(line => <p key={line} className="text-[14px] leading-snug text-body" data-id="element-272" data-mp="38w9lgljw37tu">
                      {line}
                    </p>)}
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-273" data-mp="3in4afxoisliz">
          <p className="text-[15px] leading-relaxed text-frost-100 sm:text-[17px]" data-id="element-274" data-mp="3dvvyatvt2m24">
            {PAIN_TRANSITION}
          </p>
          <p className="mt-2 font-display text-[1.8rem] font-bold uppercase text-aqua sm:text-[2.2rem]" data-id="element-275" data-mp="2q504xsbpbisr">
            {PAIN_TRANSITION_EMPHASIS}
          </p>
        </div>
      </div>
    </section>;
}